import React from 'react'
import { EXAMINATION_TERMINATING_REASON_LIST } from 'constants/path'
import { SectionGrant } from 'components/functional'
import { canShowSidebar } from 'policies/ExaminationTerminationReasonPolicy'
import MenuItem from '../MenuItem'
import { useQuery } from '../useQuery'

type Props = ReturnType<typeof useQuery>

export const ExaminationTerminationReasonMenuItem: React.FC<Props> = ({ viewer }) => {
  return (
    <SectionGrant authorized={canShowSidebar(viewer)}>
      <MenuItem href={EXAMINATION_TERMINATING_REASON_LIST}>診察終了理由</MenuItem>
    </SectionGrant>
  )
}
